import { axios } from 'src/boot/axios'
import Store from 'src/store/index'
import notifyStore from 'src/store/modules/notify/index'
// import router from 'src/router/index'

export async function RETURN_API (context, payload) {
  const {
    id,
    type,
    formType,
    deletedAddressId,
    customerData,
    addressData,
    documentData
  } = payload
  //
  const formData = new FormData()

  // CUSTOMER DATA
  let key
  for (key in customerData) {
    if (customerData[key]) {
      formData.append(key, customerData[key])
    }
  }

  formData.append('type', type)

  // DOCUMENT DATA
  if (documentData && documentData.length > 0) {
    const array = ['npwp', 'sppkp', 'nib']
    const arrayKey = ['', 'Image', 'Approval', 'Reason']
    const arrayVal = ['no', 'blobImage', 'status', 'reason']
    array.forEach((item, index) => {
      if (documentData[index].isEdit) {
        arrayVal.forEach((itemVal, indexVal) => {
          if (documentData[index][itemVal] && documentData[index][itemVal] !== 'EMPTY' && documentData[index][itemVal] !== 'undefined') {
            formData.append(item + arrayKey[indexVal], documentData[index][itemVal])
          }
        })
      }
    })
  }

  // ADDRESS DATA
  if ((deletedAddressId && deletedAddressId.length) || (addressData && addressData.length > 0)) {
    let payloadIndex = 0
    addressData.forEach((data, index) => {
      if (data.action) {
        const indexData = index

        const arrayKey = ['id', 'label', 'lat', 'long', 'address']
        const arrayValue = ['id', 'label', 'lat', 'lng', 'detail']
        arrayKey.forEach((item, index) => {
          if (data[arrayValue[index]]) {
            formData.append(`addresses[${indexData}][${item}]`, data[arrayValue[index]])
          }
        })

        formData.append(`addresses[${indexData}][action]`, data.action)

        data.receiver.forEach((receiver, index) => {
          if (receiver?.name && receiver?.phone) {
            formData.append(`addresses[${indexData}][name${index + 1}]`, receiver.name)
            formData.append(`addresses[${indexData}][phone${index + 1}]`, receiver.phone)
          }
        })
        if (data.address?.district?.id) {
          formData.append(`addresses[${indexData}][districtId]`, data.address?.district?.id)
        }
        if (data.address?.zipcode) {
          formData.append(`addresses[${indexData}][zipcode]`, data.address?.zipcode)
        }

        payloadIndex++
      }
    })

    if (deletedAddressId && deletedAddressId.length) {
      deletedAddressId.forEach(itemId => {
        formData.append(`addresses[${payloadIndex}][id]`, itemId)
        formData.append(`addresses[${payloadIndex}][action]`, 'DELETE')

        payloadIndex++
      })
    }

    if (payloadIndex === 0 && (deletedAddressId && deletedAddressId.length)) {
      deletedAddressId.forEach(itemId => {
        formData.append(`addresses[${payloadIndex}][id]`, itemId)
        formData.append(`addresses[${payloadIndex}][action]`, 'DELETE')

        payloadIndex++
      })
    }
  }

  const method = formType === 'add' ? 'POST' : 'PATCH'
  const url = formType === 'add' ? context.rootState.endpoint.customer : context.rootState.endpoint.customer + '/' + id
  await axios({
    url,
    method,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
    .then(response => {
      if (formType === 'add') {
        this.$router.push('/customer')
      }
      notifyStore.actions.FETCH_SUCCESS(Store(), response)
    })
    .catch(error => {
      notifyStore.actions.FETCH_ERROR(Store(), error)
    })
}
